import { APIModel, APIModelImpl, APIModelHandler } from '../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../utils/basecontext';
import { CreateAccountDto, CreateAccountDtoImpl } from '../../../../core/dto/createaccount/createaccountdto';
import { LoginProcessorFactory } from '../../../../core/processorfactory/loginprocessorfactory';
import { SecurityTokenResponse } from '../../../../core/api/securitytoken/securitytokenresponse';
import { CreateAccountResponse } from '../../../../core/api/createaccount/createaccountresponse';
import { SecurityTokenDtoImpl } from '../../../../core/dto/securitytoken/securitytokendto';
import { SecurityTokenRequestImpl } from '../../../../core/api/securitytoken/securitytokenrequest';
import { CreateAccountRequestImpl } from '../../../../core/api/createaccount/createaccountrequest';
import { CategoryDtoImpl, CategoryDto } from '../../../../core/dto/categories/categorydto';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { CategoriesResponse } from 'src/com/sixdee/crbtportal/core/api/categories/categoriesresponse';
import { CategoriesRequestImpl } from 'src/com/sixdee/crbtportal/core/api/categories/categoriesrequest';
import { RsaService } from 'src/com/sixdee/crbtportal/utils/rsaservice';
import { SubscriberValidationDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/subscribervalidation/subscribervalidationdto';
import { SubscriberValidationResponse } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationresponse';
import { SubscriberValidationRequestImpl } from 'src/com/sixdee/crbtportal/core/api/subscribervalidation/subscribervalidationrequest';

export interface CreateAccountAPIModel extends APIModel
{
    validateNumber(createAccountDto: CreateAccountDto): void;
    getCategories(): void;
}

export class CreateAccountAPIModelImpl extends APIModelImpl implements CreateAccountAPIModel
{
    private loginProcessorFactory: LoginProcessorFactory;
    
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);

        this.loginProcessorFactory = this.getAPIProcesssorFactory().getLoginAPIProcessorFactory();
    }

    validateNumber(createAccountDto: CreateAccountDtoImpl): void {
        let subscriberValidationDto = new SubscriberValidationDtoImpl();
        subscriberValidationDto.setMsisdn(createAccountDto.getMsisdn());
        subscriberValidationDto.setLanguage(this.getContext().getUserContext().getLanguage());

        this.loginProcessorFactory.validateSignupSubscriber()
            .success(() => {
                this.doSignUp(createAccountDto);
            })
            .failure((subscriberValidationResponse: SubscriberValidationResponse) => 
            {
                this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                        subscriberValidationResponse.getDescription(), subscriberValidationResponse);
            })
            .execute(new SubscriberValidationRequestImpl(subscriberValidationDto));
    }

    doSignUp(createAccountDto: CreateAccountDtoImpl): void 
    {
        let securityTokenDto : SecurityTokenDtoImpl = new SecurityTokenDtoImpl();

        this.loginProcessorFactory.getSecurityToken()
            .success((securityTokenResponse : SecurityTokenResponse)=>
            {
                createAccountDto.setSecurityCounter(securityTokenResponse.getSecurityCounter());

                this.createAccount(createAccountDto, securityTokenResponse.getSecurityCounter());
            })
            .failure((securityTokenResponse : SecurityTokenResponse)=>
            {
                this.getAPIModelHandler().onFailure(securityTokenResponse.getAPIFeature(), 
                securityTokenResponse.getDescription(), securityTokenResponse);
            })
            .execute(new SecurityTokenRequestImpl(securityTokenDto));
    }

      
    getCategoriesData(): CategoryDto[]
    {
        let list: CategoryDto[] = [];
      
        let categorydto1 = new CategoryDtoImpl();
        categorydto1.setId("561");
        categorydto1.setTitle("ISLAMIC");
        categorydto1.setImgPath("https://callertunes.etisalat.ae/en/islamic_small1519051932981.jpg");

        let categorydto2 = new CategoryDtoImpl();
        categorydto2.setId("515");
        categorydto2.setTitle("ENGLISH");
        categorydto2.setImgPath("https://callertunes.etisalat.ae/en/english_small1519049946025.jpg");

        let categorydto3 = new CategoryDtoImpl();
        categorydto3.setId("433");
        categorydto3.setTitle("BURMESE");
        categorydto3.setImgPath("https://callertunes.etisalat.ae/en/arabic_small1519049116830.jpg");

        let categorydto4 = new CategoryDtoImpl();
        categorydto4.setId("541");
        categorydto4.setTitle("INTERNATIONAL");
        categorydto4.setImgPath("https://callertunes.etisalat.ae/en/international_small1519051024200.jpg");

        let categorydto7 = new CategoryDtoImpl();
        categorydto7.setId("479");
        categorydto7.setTitle("SOUTHASIAN");
        categorydto7.setImgPath("https://callertunes.etisalat.ae/en/southasian_small1519053949221.jpg");


        list.push(categorydto1);
        list.push(categorydto2);
        list.push(categorydto3);
        list.push(categorydto4);
        list.push(categorydto7);
       

        return list;
    }    

    getCategories(): void 
    {
        let categoryDto = new CategoryDtoImpl();
        categoryDto.setLanguage(this.getContext().getUserContext().getLanguage());
        
        this.getAPIProcesssorFactory().getCategoriesAPIProcessorFactory().getCategories()
                   .success((categoriesResponse : CategoriesResponse)=>
                    {
                        this.getAPIModelHandler().onSuccess(APIFeatures.SIGNUP_CATEGORIES, 
                        categoriesResponse.getDescription(), categoriesResponse.getCategoriesList()); 
                    })
                  .failure((categoriesResponse : CategoriesResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(APIFeatures.SIGNUP_CATEGORIES, 
                      categoriesResponse.getDescription(), categoriesResponse);
                    // this.getAPIModelHandler().onSuccess(APIFeatures.SIGNUP_CATEGORIES, 
                    //     categoriesResponse.getDescription(), this.getCategoriesData()); 
                    })
                  .execute(new CategoriesRequestImpl(categoryDto));
        // this.getAPIProcesssorFactory().getSignupCategoriesProcessorFactory().getSignupCategoriesDetails()
        // .success((signUpCategoriesResponse : SignupCategoriesResponse)=>
        // {
        //     this.getAPIModelHandler().onSuccess(signUpCategoriesResponse.getAPIFeature(), 
        //     signUpCategoriesResponse.getDescription(), signUpCategoriesResponse.getSignupCategoriesDtos());
        // })
        // .failure((signUpCategoriesResponse : SignupCategoriesResponse)=>
        // {
        //     this.getAPIModelHandler().onFailure(signUpCategoriesResponse.getAPIFeature(), 
        //     signUpCategoriesResponse.getDescription(), {});
        // })
        // .execute(new SignupCategoriesRequestImpl(new CategoryDtoImpl()));
    }

    private createAccount(createAccountDto: CreateAccountDto, securityToken: string)
    {
        let encryptedPassword = RsaService.getInstance(this.getContext().getProperty()).encryptWithNodeRSA(createAccountDto.getPassword() + securityToken
        );

        (createAccountDto as CreateAccountDtoImpl).setEncryptedPassword(encryptedPassword);
        this.loginProcessorFactory.createAccount()
        .success((createAccountResponse : CreateAccountResponse)=>
        {
            // this.getContext().getUserContext().setMsisdnB(createAccountDto.getMsisdn());
            // this.getContext().getUserContext().setSecToken(createAccountResponse.getCreateAccountDetails().getSecToc());
              
            // this.getContext().setUserContext(this.getContext().getUserContext());
            this.getAPIModelHandler().onSuccess(createAccountResponse.getAPIFeature(), 
            createAccountResponse.getDescription(), createAccountResponse.getCreateAccountDetails());
        })
        .failure((createAccountResponse : CreateAccountResponse)=>
        {
            this.getAPIModelHandler().onFailure(createAccountResponse.getAPIFeature(), 
            createAccountResponse.getDescription(), createAccountResponse);

           
        })
        .execute(new CreateAccountRequestImpl(createAccountDto));
    }

   
}





// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/login/createaccountcomponent/createaccountapimodel.tsx